import { render, staticRenderFns } from "./formazione.html?vue&type=template&id=307287d0&external"
import script from "./Formazione.vue?vue&type=script&lang=js"
export * from "./Formazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports